"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEarlyBirdDiscountFriendlyArray = void 0;
const getEarlyBirdDiscountFriendlyArray = (discounts) => {
    const text = [];
    discounts.forEach((discount) => {
        text.push(`Discount of ${discount.discount_percentage}% if booked at least ${discount.min_days_in_advance} days in advance`);
    });
    return text;
};
exports.getEarlyBirdDiscountFriendlyArray = getEarlyBirdDiscountFriendlyArray;
